import { Fraction } from 'bi-fraction';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface H2SwapSlippageDialogStore {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  enteredStr: string;
  entered: Fraction;
  setEnteredStr: (enteredStr: string) => void;
  confirm: () => void;
}

export const useH2SwapSlippageDialog = create(
  persist<H2SwapSlippageDialogStore>(
    (set, get) => ({
      isOpen: false,
      enteredStr: '0.01',
      entered: new Fraction(0.01),
      setEnteredStr: (enteredStr: string) => {
        set({
          enteredStr,
        });
      },
      close: () => set({ isOpen: false }),
      confirm: () => {
        const parsed = Fraction.tryParse(get().enteredStr) ?? Fraction.ZERO;
        if (parsed.lte(2) && parsed.gt(0))
          set({ entered: parsed.div(100), isOpen: false });
      },
      open: () => {
        set({
          isOpen: true,
        });
      },
    }),
    {
      name: '__H2_SWAP_SLIPPAGE_DIALOG__',
      version: 1,
      serialize: (state) => {
        return JSON.stringify({
          ...state,
          state: {
            ...state.state,
            entered: state.state.entered.toFixed(4),
          },
        });
      },
      deserialize: (str) => {
        const state = JSON.parse(str);
        return {
          ...state,
          state: {
            ...state.state,
            entered:
              Fraction.tryParse(state.state.entered) ?? new Fraction(0.01),
          },
        };
      },
    },
  ),
);
